import React, { useEffect } from 'react';
import { useQuery } from 'hooks/use-query/use-query';
import { Loading } from 'ui-components/loading/loading-component';
import { useAuthActions } from 'store/auth/use-auth-actions';
import { useHistory } from 'react-router-dom';

export const CompleteMfaLogin = () => {
    const { mfaLogin } = useAuthActions();
    const history = useHistory();
    const token = useQuery('token') || '';
    const next_url = useQuery('next_url') || '';
    const email = useQuery('email') || '';

    const completeLogin = async () => {
        try {
            await mfaLogin(token, decodeURIComponent(next_url));
        } catch (error) {
            history.push('email-expired?email=' + email);
        }
    };

    useEffect(() => {
        completeLogin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Loading className="pl-app-loader" show={true} />
    );
};
